/* unplugin-vue-components disabled */import iMenuSideItem from './menu-item';
import iMenuSideTitle from './menu-title';
import siderMenuBadge from '../mixins/sider-menu-badge';
export default {
  name: 'iMenuSideSubmenu',
  components: {
    iMenuSideItem: iMenuSideItem,
    iMenuSideTitle: iMenuSideTitle
  },
  mixins: [siderMenuBadge],
  props: {
    menu: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};